/*
<summary>
   This file is used to provide initial values or state to the Process Module Observables.
   Developer:Urvashi, Created Date: 21-November-2024
</summary>
*/
import {
  IBaseProcessTemplateListVM,
  IProcessTemplateListVM,
} from '../../models/response/IProcessTemplateResponse';
const initialProcessTemplateState: IProcessTemplateListVM = {
  PagingDetails: {
    TotalRecords: 1,
    TotalPages: 1,
    CurrentPage: 1,
    PageSize: 10,
  },
  processTemplates: [],
};

export const initialProcessTemplateStateNew: IBaseProcessTemplateListVM = {
  processTemplates: [],
};

export default initialProcessTemplateState;
